import { useEffect, useState } from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Outlet, NavLink, Link } from 'react-router-dom';
import {
  BsArrowLeft,
  BsBookFill,
  BsClockHistory,
  BsEnvelopeFill,
  BsGearFill,
  BsPaletteFill,
  BsPeopleFill,
  BsQuestionCircleFill,
} from 'react-icons/bs';
import { useAuth } from '@context';
import { repositoryFactory } from '@data';
import { ROUTES } from '@config/routes';

export function AdminLayout() {
  const { user } = useAuth();
  const [setupStatus, setSetupStatus] = useState({ loading: true, complete: false });
  const canManageGlobalSettings = user?.role === 'admin';

  useEffect(() => {
    const loadSetupStatus = async () => {
      if (user?.role !== 'admin') {
        setSetupStatus({ loading: false, complete: false });
        return;
      }

      try {
        const userRepository = repositoryFactory.getUserRepository();
        const users = await userRepository.getAllUsers();
        setSetupStatus({ loading: false, complete: users.length > 0 });
      } catch {
        setSetupStatus({ loading: false, complete: false });
      }
    };

    loadSetupStatus();
  }, [user]);

  return (
    <div className="admin-layout">
      <Container fluid className="p-0">
        <Row className="g-0">
          <Col xs={12} md={3} lg={2} className="admin-sidebar min-vh-100 py-3 d-flex flex-column"
            style={{ background: '#1e293b' }}>
            <div className="px-3 mb-4">
              <div className="fw-bold fs-5 mb-1" style={{ color: '#f1f5f9' }}>⚙️ Admin Panel</div>
              <div className="small" style={{ color: '#94a3b8' }}>Course Management</div>
            </div>
            <Nav className="flex-column px-2 flex-grow-1">
              <Nav.Link
                as={NavLink}
                to="/admin/courses"
                className="admin-nav-link d-flex align-items-center gap-2 rounded mb-1 px-3 py-2"
                style={({ isActive }) => ({
                  color: isActive ? '#fff' : '#94a3b8',
                  background: isActive ? '#334155' : 'transparent',
                  fontWeight: isActive ? 600 : 400,
                })}
              >
                <BsBookFill /> Courses
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/admin/questions"
                className="admin-nav-link d-flex align-items-center gap-2 rounded mb-1 px-3 py-2"
                style={({ isActive }) => ({
                  color: isActive ? '#fff' : '#94a3b8',
                  background: isActive ? '#334155' : 'transparent',
                  fontWeight: isActive ? 600 : 400,
                })}
              >
                <BsQuestionCircleFill /> Question Bank
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/admin/users"
                className="admin-nav-link d-flex align-items-center gap-2 rounded mb-1 px-3 py-2"
                style={({ isActive }) => ({
                  color: isActive ? '#fff' : '#94a3b8',
                  background: isActive ? '#334155' : 'transparent',
                  fontWeight: isActive ? 600 : 400,
                })}
              >
                <BsPeopleFill /> Users
              </Nav.Link>
              {canManageGlobalSettings && (
                <>
                  <Nav.Link
                    as={NavLink}
                    to={ROUTES.ADMIN_BRANDING}
                    className="admin-nav-link d-flex align-items-center gap-2 rounded mb-1 px-3 py-2"
                    style={({ isActive }) => ({
                      color: isActive ? '#fff' : '#94a3b8',
                      background: isActive ? '#334155' : 'transparent',
                      fontWeight: isActive ? 600 : 400,
                    })}
                  >
                    <BsPaletteFill /> Branding
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to={ROUTES.ADMIN_EMAILS}
                    className="admin-nav-link d-flex align-items-center gap-2 rounded mb-1 px-3 py-2"
                    style={({ isActive }) => ({
                      color: isActive ? '#fff' : '#94a3b8',
                      background: isActive ? '#334155' : 'transparent',
                      fontWeight: isActive ? 600 : 400,
                    })}
                  >
                    <BsEnvelopeFill /> Emails
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to={ROUTES.ADMIN_EMAIL_LOGS}
                    className="admin-nav-link d-flex align-items-center gap-2 rounded mb-1 px-3 py-2"
                    style={({ isActive }) => ({
                      color: isActive ? '#fff' : '#94a3b8',
                      background: isActive ? '#334155' : 'transparent',
                      fontWeight: isActive ? 600 : 400,
                    })}
                  >
                    <BsClockHistory /> Email Logs
                  </Nav.Link>
                </>
              )}
              {canManageGlobalSettings && (
                <Nav.Link
                  as={NavLink}
                  to={ROUTES.ADMIN_EMAIL_CONFIG}
                  className="admin-nav-link d-flex align-items-center gap-2 rounded mb-1 px-3 py-2"
                  style={({ isActive }) => ({
                    color: isActive ? '#fff' : '#94a3b8',
                    background: isActive ? '#334155' : 'transparent',
                    fontWeight: isActive ? 600 : 400,
                  })}
                >
                  <BsGearFill /> Email Config
                </Nav.Link>
              )}
            </Nav>
            <div className="px-3 mt-auto pt-3" style={{ borderTop: '1px solid #334155' }}>
              {user?.role === 'admin' && (
                <div className="small mb-2" style={{ color: '#94a3b8' }}>
                  Setup Status:{' '}
                  {setupStatus.loading
                    ? 'Checking...'
                    : setupStatus.complete
                      ? 'Complete'
                      : 'Required'}
                </div>
              )}
              <Link to="/" className="d-flex align-items-center gap-2 small text-decoration-none" style={{ color: '#94a3b8' }}>
                <BsArrowLeft /> Back to Site
              </Link>
            </div>
          </Col>
          <Col xs={12} md={9} lg={10} className="py-4 px-4" style={{ background: '#f8fafc', minHeight: '100vh' }}>
            <Outlet />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
